import { remove } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { z } from "zod";

import { WORKPLACE_WORKERS_ENDPOINT_URL } from "../useGetWorkerDetailsAtWorkplace";
import { getWorkplaceStarredProfessionalsUrl } from "./useGetWorkplaceStarredProfessionals";

export function useDeleteStarredProfessional(params: {
  workplaceId: string;
  starredProfessionalId: string;
}) {
  const { workplaceId, starredProfessionalId } = params;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await remove({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}/starred-professionals/${starredProfessionalId}`,
        responseSchema: z.literal(""),
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [getWorkplaceStarredProfessionalsUrl(workplaceId)],
      });
      await queryClient.invalidateQueries({
        queryKey: [WORKPLACE_WORKERS_ENDPOINT_URL],
      });
    },
    meta: {
      userSuccessMessage: "Professional removed from your starred list",
      logErrorMessage: APP_V2_APP_EVENTS.DELETE_WORKPLACE_STARRED_PROFESSIONAL_FAILURE,
      userErrorMessage:
        "There was an error removing this professional from your starred list. Please try again later.",
    },
  });
}
